import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { format } from 'date-fns';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AlertMessageBoxComponent } from '../alert-message-box/alert-message-box.component';
import { ActionItemComponent } from './action-item/action-item.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'uw-actions-modal',
    templateUrl: './actions-modal.component.html',
    styleUrls: ['./actions-modal.component.scss'],
    imports: [ReactiveFormsModule, MatProgressBar, MatIconButton, MatIcon, AlertMessageBoxComponent, ActionItemComponent, MatButton, TranslateModule]
})
export class ActionsModalComponent implements OnInit {
  viewLoading = false;
  errorMessage: string | null = null;
  disableSave = false;
  actionsForm: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<ActionsModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      selectedAccounts: { accountCode: string; accountNumber: string }[];
    }
  ) {
    this.actionsForm = this.fb.group({
      actions: this.fb.array([]),
    });
  }

  ngOnInit() {
    this.data.selectedAccounts.map((a) => {
      this.actionsFormArray.push(this.createAction());
    });
  }

  get actionsFormArray() {
    const arr = this.actionsForm?.get('actions') as UntypedFormArray;
    return arr.controls;
  }

  createAction(): UntypedFormGroup {
    return this.fb.group({
      account: '',
      action: '',
      actionDate: format(new Date(), 'dd-MM-yyyy'),
      followUpDate: '',
      writeOffDate: '',
      amount: '',
      agency: '',
      specialAssignment: '',
      userLastUpdate: '',
      remarks: '',
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  saveChanges() {}
}
